export const percentageFormater = new Intl.NumberFormat("de-DE", {
    style: "percent",
    maximumFractionDigits: 2, 
    minimumFractionDigits: 2
});